var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainDisclaimerInfoCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 2.66667C8.65333 2.66667 2.66667 8.65333 2.66667 16C2.66667 23.3467 8.65333 29.3333 16 29.3333C23.3467 29.3333 29.3333 23.3467 29.3333 16C29.3333 8.65333 23.3467 2.66667 16 2.66667ZM15 10.6667C15 10.12 15.4533 9.66667 16 9.66667C16.5467 9.66667 17 10.12 17 10.6667V17.3333C17 17.88 16.5467 18.3333 16 18.3333C15.4533 18.3333 15 17.88 15 17.3333V10.6667ZM17.2267 21.84C17.16 22.0133 17.0667 22.1467 16.9467 22.28C16.8133 22.4 16.6667 22.4933 16.5067 22.56C16.3467 22.6267 16.1733 22.6667 16 22.6667C15.8267 22.6667 15.6533 22.6267 15.4933 22.56C15.3333 22.4933 15.1867 22.4 15.0533 22.28C14.9333 22.1467 14.84 22.0133 14.7733 21.84C14.7067 21.68 14.6667 21.5067 14.6667 21.3333C14.6667 21.16 14.7067 20.9867 14.7733 20.8267C14.84 20.6667 14.9333 20.52 15.0533 20.3867C15.1867 20.2667 15.3333 20.1733 15.4933 20.1067C15.8133 19.9733 16.1867 19.9733 16.5067 20.1067C16.6667 20.1733 16.8133 20.2667 16.9467 20.3867C17.0667 20.52 17.16 20.6667 17.2267 20.8267C17.2933 20.9867 17.3333 21.16 17.3333 21.3333C17.3333 21.5067 17.2933 21.68 17.2267 21.84Z",
    fill: "var(--fill-0, #FFA400)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainDisclaimerInfoCircle);
export default __webpack_public_path__ + "static/media/train-disclaimer-info-circle.e79862317cb378396dd56001e6ad7443.svg";
export { ForwardRef as ReactComponent };